import { createApi, } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../../utils/general";

export const resultApiSlice = createApi({
  reducerPath: "resultApi",
  tagTypes: ["Result"],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getResultById: builder.query({
      query: ({ id }) => ({
        url: `/results/${id}`,
      }),
      providesTags: (result, error, arg) => [
        { type: "Result", id: result?._id },
        "Result",
      ],
    }),
    getResults: builder.query({
      query: () => ({
        url: `/results`,
      }),
      providesTags: (result, error, arg) => [
        { type: "Result", id: "RESULT_LIST" },
        "Result",
      ],
    }),
    saveResult: builder.mutation({
      query: ({ body, id }) => ({
        url: `/results/save/${id}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (res, error, arg) => [
        {
          type: "Result",
          id: arg.id,
        },
      ],
    }),
    editResult: builder.mutation({
      query: ({ body, id }) => ({
        url: `/results/edit/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: "Result",
          id: arg.id,
        },
        "Result",
      ],
    }),

    changeResultVisibility: builder.mutation({
      query: ({ body, id }) => ({
        url: `/results/edit/state/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, err, arg) => [
        {
          type: "Result",
          id: arg?.id,
        },
        "Result",
      ],
    }),
    removeResult: builder.mutation({
      query: ({ id }) => ({
        url: `/results/remove/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: (result, err, arg) => [
        {
          type: "Result",
          id: arg?.id,
        },
        "Result",
      ],
    }),
    likeResult: builder.mutation({
      query: ({ id }) => ({
        url: `/results/like/${id}`,
        method: "POST",
      }),
      // Don't invalidate to prevent unnecessary refetch
      invalidatesTags: [],
    }),
    dislikeResult: builder.mutation({
      query: ({ id }) => ({
        url: `/results/dislike/${id}`,
        method: "POST",
      }),
      // Don't invalidate to prevent unnecessary refetch
      invalidatesTags: [],
    }),
    addResultComment: builder.mutation({
      query: ({ id, body }) => ({
        url: `/results/comments/add/${id}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: "Result",
          id: arg.id,
        },
        "Result",
      ],
    }),
    editResultComment: builder.mutation({
      query: ({ id, body }) => ({
        url: `/results/comments/edit/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: "Result",
          id: arg.id,
        },
        "Result",
      ],
    }),
    deleteResultComment: builder.mutation({
      query: ({ id }) => ({
        url: `/results/comments/remove/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: "Result",
          id: arg.id,
        },
        "Result",
      ],
    }),
  }),
});

export const {
  useChangeResultVisibilityMutation,
  useEditResultMutation,
  useGetResultByIdQuery,
  useSaveResultMutation,
  useRemoveResultMutation,
  useGetResultsQuery,
  useDislikeResultMutation,
  useLikeResultMutation,
  useLazyGetResultsQuery,
  useLazyGetResultByIdQuery,
  useAddResultCommentMutation,
  useEditResultCommentMutation,
  useDeleteResultCommentMutation,
} = resultApiSlice;
